import IUser from "@/models/protocols/IUser";
import { Cart } from "@/types/Cart";

const setProducts = ({ commit }: { commit: Function }) => {
  commit("SET_PRODUCTS");
};

const setUser = ({ commit }: { commit: Function }, user: IUser) => {
  // eslint-disable-next-line no-console
  console.log("action", user);
  commit("SET_USER", user);
};

const setCart = ({ commit }: { commit: Function }, cart: Cart) => {
  // eslint-disable-next-line no-console
  console.log("action", cart);
  commit("SET_CART", cart);
};

const setRegions = ({ commit }: { commit: Function }, regions: any) => {
  commit("SET_REGIONS", regions);
};

const setUnderMaintenance = (
  { commit }: { commit: Function },
  underMaintenance: Boolean
) => {
  commit("SET_UNDER_MAINTENANCE", underMaintenance);
};

export default {
  setProducts,
  setUser,
  setCart,
  setRegions,
  setUnderMaintenance,
};
